export const RESULTS_PER_PAGE = 'RESULTS_PER_PAGE'
